import { ADD_PARTICIPANT_TO_SPACE } from '../../constants/endpoints';
import request from '../request';

const addParticipantToSpace = async ({ spaceId, role, userId }) => {
  const user = await request({
    method: 'POST',
    url: ADD_PARTICIPANT_TO_SPACE(spaceId),
    data: {
      user: userId,
      role,
    },
  });
  return user;
};

export default addParticipantToSpace;
